module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v("Zoom")]), _vm._v(" "), _c('v-tab', [_vm._v("Manually configure")]), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n            Make this appointment online\n            "), _c('v-spacer'), _vm._v(" "), (_vm.integrationIsConnected) ? _c('v-chip', {
    attrs: {
      "small": "",
      "dark": "",
      "color": "success"
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v("\n              Zoom Connected\n            ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.appointment.is_online) ? _c('v-alert', {
    attrs: {
      "type": "success",
      "value": _vm.appointment.is_online
    }
  }, [_vm._v("\n            This appointment is online\n          ")]) : _vm._e(), _vm._v(" "), (_vm.integrationIsConnected) ? [(_vm.zoommeeting) ? _c('online-meeting-card', {
    attrs: {
      "appointment": _vm.zoommeeting
    }
  }) : _c('v-list', {
    staticClass: "elevation-0"
  }, [(_vm.appointment) ? _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.appointment,
      "with-color-coding": false
    }
  }, [(!_vm.appointment.is_online) ? _c('v-list-tile-action', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "small": ""
    },
    on: {
      "click": _vm.makeOnline
    }
  }, [_vm._v("\n                    Make online\n                  ")])], 1) : _vm._e()], 1) : _vm._e()], 1)] : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 subheading"
  }, [_vm._v("\n              Connect to your Zoom account\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": "https://appointmentguru.co/help/zoom-integration/",
      "flat": "",
      "text": "",
      "target": "_blank"
    }
  }, [_vm._v("Learn more "), _c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), (_vm.isEnabled) ? _c('v-btn', {
    attrs: {
      "href": _vm.oauthUrl,
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("\n                Install "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _c('v-btn', {
    attrs: {
      "outline": "",
      "disabled": "",
      "href": _vm.oauthUrl,
      "color": "primary"
    }
  }, [_vm._v("\n                Coming soon\n              ")])], 1), _vm._v(" "), _c('v-card-text', [_c('ul', [_c('li', [_c('strong', [_vm._v("To create online appointments, you will need to configure an integration with\n                  "), _c('a', {
    attrs: {
      "href": "https://zoom.us",
      "target": "_blank"
    }
  }, [_vm._v("Zoom")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Zoom is a tool for doing online meetings")]), _vm._v(" "), _c('li', [_vm._v("Zoom is free to use for 1-on-1 meetings")]), _vm._v(" "), _c('li', [_vm._v("Zoom is free to use for group meetings shorter than 40 minutes")]), _vm._v(" "), _c('li', [_vm._v("There are paid plans should you need more")])])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("With the AppointmentGuru integration, you can:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Make an appointment into an \"online appointment\"")]), _vm._v(" "), _c('li', [_vm._v("AppointmentGuru will automatically create the meeting in Zoom and make all the relevent information available to you and easy to share")]), _vm._v(" "), _c('li', [_vm._v("Automatically add meeting information to your notifications")]), _vm._v(" "), _c('li', [_vm._v("Easily share Zoom meeting information with your clients")]), _vm._v(" "), _c('li', [_vm._v("Start the meeting directly from AppointmentGuru")])])])])])], 1)], 2)], 1), _vm._v(" "), _c('v-tab-item', [(_vm.appointment) ? _c('online-meeting-card', {
    attrs: {
      "editmode": true,
      "appointment": _vm.appointment
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7deaf6c7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Zoom/MakeAppointmentOnline.vue
// module id = 1483
// module chunks = 9